module.exports = __webpack_public_path__ + "static/media/paint_brush.949e902c.cur";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/cursors/paint_brush.cur
// module id = 518
// module chunks = 0